function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "_clip1"
}, React.createElement("path", {
  d: "M0 .03h38v22H0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 1,
  strokeOpacity: 0.05,
  strokeWidth: 2,
  clipPath: "url(#_clip1)"
}, React.createElement("path", {
  d: "M36.2 14.3l3.81 2.2M34.295 22l3.81-2.2M-1.8 14.3l15.137 8.8M9.631-1.1l15.242 8.8 3.811-2.2 3.81 2.2-7.621 4.4-7.621-4.4-3.81 2.2 9.526 5.5-3.81 2.2-5.716-3.3-3.811 2.2 10.422 6.077"
}), React.createElement("path", {
  d: "M-1.8 9.9l7.621 4.4 3.81-2.2-5.715-3.3 3.81-2.2 1.905 1.1 3.811-2.2L2.01-1.1"
}), React.createElement("path", {
  d: "M-1.8 1.1l5.716 3.3L.105 6.6-1.8 5.5m30.379 17.6l-5.716-3.3 3.811-2.2 3.81 2.2 3.811-2.2-5.716-3.3L36.2 9.9l3.81 2.2M4.811 22.577L.105 19.8-1.8 20.9M18.053-.577L24.768 3.3l3.811-2.2-3.811-2.2m11.432 0L34.295 0l5.715 3.3m-7.621 0l5.716 3.3 1.905-1.1"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41,
    clipRule: "evenodd",
    viewBox: "0 0 38 22"
  }, props), _ref, _ref2);
};

export default 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEuNDEiIGNsaXAtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iMCAwIDM4IDIyIj4KICAgIDxjbGlwUGF0aCBpZD0iX2NsaXAxIj4KICAgICAgICA8cGF0aCBkPSJNMCAuMDNoMzh2MjJIMHoiLz4KICAgIDwvY2xpcFBhdGg+CiAgICA8ZyBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEiIHN0cm9rZS1vcGFjaXR5PSIuMDUiIHN0cm9rZS13aWR0aD0iMiIgY2xpcC1wYXRoPSJ1cmwoI19jbGlwMSkiPgogICAgICAgIDxwYXRoIGQ9Ik0zNi4yIDE0LjNsMy44MSAyLjJNMzQuMjk1IDIybDMuODEtMi4yTS0xLjggMTQuM2wxNS4xMzcgOC44TTkuNjMxLTEuMWwxNS4yNDIgOC44IDMuODExLTIuMiAzLjgxIDIuMi03LjYyMSA0LjQtNy42MjEtNC40LTMuODEgMi4yIDkuNTI2IDUuNS0zLjgxIDIuMi01LjcxNi0zLjMtMy44MTEgMi4yIDEwLjQyMiA2LjA3NyIvPgogICAgICAgIDxwYXRoIGQ9Ik0tMS44IDkuOWw3LjYyMSA0LjQgMy44MS0yLjItNS43MTUtMy4zIDMuODEtMi4yIDEuOTA1IDEuMSAzLjgxMS0yLjJMMi4wMS0xLjEiLz4KICAgICAgICA8cGF0aCBkPSJNLTEuOCAxLjFsNS43MTYgMy4zTC4xMDUgNi42LTEuOCA1LjVtMzAuMzc5IDE3LjZsLTUuNzE2LTMuMyAzLjgxMS0yLjIgMy44MSAyLjIgMy44MTEtMi4yLTUuNzE2LTMuM0wzNi4yIDkuOWwzLjgxIDIuMk00LjgxMSAyMi41NzdMLjEwNSAxOS44LTEuOCAyMC45TTE4LjA1My0uNTc3TDI0Ljc2OCAzLjNsMy44MTEtMi4yLTMuODExLTIuMm0xMS40MzIgMEwzNC4yOTUgMGw1LjcxNSAzLjNtLTcuNjIxIDBsNS43MTYgMy4zIDEuOTA1LTEuMSIvPgogICAgPC9nPgo8L3N2Zz4K';
export { SvgComponent as ReactComponent };